
import { ZoneApi } from "@/api/ZoneApi";
import { SalemanApi } from "@/api/SalemenApi";
import { CUSTOM_ELEMENT, EDITOR_INPUT, PHONE_INPUT_TYPE, RADIO_INPUT_TYPE, SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { CLIENT_TYPES, DISCOUNT_CODES, DISCOUNT_TYPES, EINVOICE_INVOICE_TYPE_CODE, EINVOICE_TYPES, ON_INVOICE_DISCOUNT_TYPE_CODE, RECEPTOR_TAX_REGIME_GENERAL, RECEPTOR_TAX_REGIME_OPTIONS, TIPOS_DE_IDENTIFICACION } from "@utils/Constants";
import { OpenSearchClientByIdentificationPubSub } from "@utils/pubsubs/PubSub";
import { identificationRequiredWhen, nombreComercialValidation, optionalPhoneForEinvoice, phoneRequiredForEinvoice } from "@utils/Forms";
import { Button } from "reactstrap";

const ClientFormConfig = {
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "checkbox",
                        "name": "is_default",
                        "label": "Cliente por defecto",
                        "sizing": {
                            "sm": {
                                "offset": "2"
                            }
                        },
                    },
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "active",
                        "label": "Cliente Activo",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        },
                        "defaultValue": true
                    }
                ],
                [
                    {
                        "type": "checkbox",
                        "name": "with_user_info",
                        "label": "Imprimir informacion del cliente en el Factura ?",
                        "sizing": {
                            "sm": {
                                "offset": 2
                            }
                        },
                        "defaultValue": true
                    }
                ],
                [
                    {
                        "type": RADIO_INPUT_TYPE,
                        "name": "tipo",
                        "isHorizontal": true,
                        "validation": Yup.string().required(),
                        "label": "Tipo Cliente",
                        "labelSizing": {
                            "sm": {
                                "size": 2
                            }
                        },
                        "sizing": {
                            "sm": {
                                "size": 6
                            }
                        },
                        "options": CLIENT_TYPES,
                        "defaultValue": 0
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "codigo",
                        "label": "Codigo",
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "nombre",
                        "label": "Nombre",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "nombre_comercial",
                        "label": "Nombre Comercial",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                        "maxlength": 80,
                        "validation": nombreComercialValidation(),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_identificacion",
                        "label": "Tipo identificacion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": TIPOS_DE_IDENTIFICACION,
                        "validation": Yup.string().when("einvoice_kind", {
                            is: (einvoice_kind: unknown) => einvoice_kind == EINVOICE_INVOICE_TYPE_CODE,
                            then: (s) => s.required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "identificacion",
                        "label": "Identificacion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": identificationRequiredWhen(),
                        "suffixButton": true,
                        "suffix": <Button
                            block
                            className="rounded-0"
                            color="primary"
                            type="button"
                            onClick={() => OpenSearchClientByIdentificationPubSub.publish({ openOffCanvas: true })}>
                            Buscar
                        </Button>
                    }
                ],
                [
                    {
                        "type": PHONE_INPUT_TYPE,
                        "name": "telefono1",
                        "label": "Telefono 1",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": phoneRequiredForEinvoice(),
                    }
                ],
                [
                    {
                        "type": PHONE_INPUT_TYPE,
                        "name": "telefono2",
                        "label": "Telefono 2",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        "validation": optionalPhoneForEinvoice(),
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "email",
                        "label": "Email",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "validation": Yup.string().when("einvoice_kind", {
                            is: (einvoice_kind: unknown) => einvoice_kind == EINVOICE_INVOICE_TYPE_CODE,
                            then: (s) => s.required("El campo de email es obligatorio")
                                .test("is-valid-emails", "Uno o más correos no son válidos", (value) => {
                                    if (!value) return false;

                                    // Separar por coma y limpiar espacios
                                    const emails = value.split(",").map((email) => email.trim());

                                    // Validar cada correo usando una expresión regular o Yup
                                    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                                    return emails.every((email) => emailRegex.test(email));
                                }),
                            otherwise: (s) => s.notRequired(),
                        }),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "priceId",
                        "label": "Tipo de Precio",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        }
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "zoneId",
                        "label": "Zona de Cliente",
                        "optionsFunction": () => ZoneApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        }
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "salemanId",
                        "label": "Vendedor",
                        "optionsFunction": () => SalemanApi.optionsList(),
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        }
                    },
                ],
                [
                    {
                        "type": "number",
                        "name": "plazo",
                        "label": "Plazo de Credito",
                        "suffix": "Dias",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "money",
                        "name": "credit_limit",
                        "label": "Limite de Credito",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 3
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "descuento",
                        "label": "Porcentaje Descuento",
                        "suffix": "%",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 2
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "tipo_descuento",
                        "label": "Tipo Descuento",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": DISCOUNT_TYPES,
                        "defaultValue": 1
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "discountCode",
                        "label": "Codigo de Descuento por Defecto",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": DISCOUNT_CODES,
                        "validation": Yup.string().when(["tipo_descuento", "descuento"], {
                            is: (tipo_descuento: unknown, descuento: unknown) => Number(descuento || 0) > 0 && tipo_descuento == ON_INVOICE_DISCOUNT_TYPE_CODE,
                            then: (s) => s.required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "einvoice_kind",
                        "label": "Tipo de Factura Electronica",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": EINVOICE_TYPES,
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        // El editor de opciones lo inyecta `ClientForm` en su `useMemo`:
                        // necesita el estado del componente y la lista de proveedores.
                        "type": CUSTOM_ELEMENT,
                        "name": "shipping_data",
                        "label": "Opciones de Envio",
                        "isHorizontal": true,
                        "exludeFromSubmit": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 10
                        },
                        "element": null,
                    }
                ],
                [
                    {
                        "type": "text",
                        "name": "contacto",
                        "label": "Nombre de Contacto",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        }
                    },
                ],
                [
                    {
                        "type": "text",
                        "name": "activitycode",
                        "label": "Codigo Actividad Economica",
                        "maxlength": 6,
                        "isHorizontal": true,
                        "sizing": {
                            "sm": 2
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "validation": Yup.string().when("einvoice_kind", {
                            is: (einvoice_kind: unknown) => einvoice_kind == EINVOICE_INVOICE_TYPE_CODE,
                            then: (s) => s.required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR)
                                .length(6, "Se permite solo 6 caracteres para este codigo"),
                            otherwise: (s) => s.notRequired(),
                        }),
                    },
                ],
                [
                    {
                        // Tarifa que la ley fija por quien compra (Ley del IVA art. 11), no por el
                        // producto: al facturarle, las lineas que gravan mas se rebajan a esta.
                        "type": SELECT_INPUT_TYPE,
                        "name": "tax_regime",
                        "label": "Tarifa especial de IVA",
                        "isHorizontal": true,
                        "defaultValue": RECEPTOR_TAX_REGIME_GENERAL,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 6
                        },
                        "options": RECEPTOR_TAX_REGIME_OPTIONS,
                    },
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "direccion",
                        "label": "Direccion",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
                [
                    {
                        "type": EDITOR_INPUT,
                        "name": "cuentas_bancarias",
                        "label": "Cuentas Bancarias",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 8
                        },
                        // "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
            ]
        }
    ],
};


export default ClientFormConfig;